import React from "react";
import { useNavigate } from "react-router-dom";

const MobileRestrictionMessage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Check if user is authenticated to determine where to redirect
    const isAuthenticated = !!localStorage.getItem("idToken") || !!localStorage.getItem("accessToken");
    
    if (isAuthenticated) {
      // If authenticated, go to welcome page for now, maybe we can redirect to dashboard later
      navigate("/welcome");
    } else {
      // If not authenticated, go to welcome page (login/signup options)
      navigate("/welcome");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#2F2D2D] text-white px-4">
      <div className="bg-[#232323] rounded-lg p-6 sm:p-8 max-w-md w-full text-center shadow-lg border border-gray-600">
        {/* Icon or Logo */}
        <div className="mb-6">
          <img
            src="/assets/images/puppy-2.png"
            alt="Pounce Logo"
            className="w-24 h-24 mx-auto object-contain"
          />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-[#CBDF52] mb-4">
          Larger Screen Required
        </h1>

        {/* Message */}
        <p className="text-gray-300 text-base leading-relaxed mb-6">
          To accurately mark behaviors in the puppy videos, you'll need to use a laptop, desktop computer, or tablet with a larger screen.
        </p>

        <p className="text-gray-400 text-sm mb-8">
          The precise nature of this task requires a larger screen to avoid any misclicks or errors.
        </p>

        {/* Action Button */}
        <button
          onClick={handleGoBack}
          className="w-full bg-[#CBDF52] text-black font-semibold py-3 px-6 rounded-lg hover:bg-[#B0C947] transition duration-300"
        >
          Got it, take me back
        </button>

        {/* Additional info */}
        <p className="text-gray-500 text-xs mt-4">
          You can still create your account on mobile and return later on a device with a larger screen.
        </p>
      </div>
    </div>
  );
};

export default MobileRestrictionMessage;
